import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CommonServices } from "src/app/common.services";
import { AdminAddNotesComponent } from "../admin-add-notes/admin-add-notes.component";
import { AdminCancelTripComponent } from "../admin-cancel-trip/admin-cancel-trip.component";
import { AdminTripsViewComponent } from "../admin-trips-view/admin-trips-view.component";
import { AdminTruckownerPaymentComponent } from "../admin-truckowner-payment/admin-truckowner-payment.component";
import { AdminService } from "../admin.service";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AdminTripsCancelComponent } from "../admin-trips-cancel/admin-trips-cancel.component";
import { AdminEditTripsComponent } from "../admin-edit-trips/admin-edit-trips.component";
import { AdminRetailNotifyDriverComponent } from "../admin-retail-notify-driver/admin-retail-notify-driver.component";
import { AdminRetailEditTripsComponent } from "../admin-retail-edit-trips/admin-retail-edit-trips.component";
import { AdminEditTripsRetailComponent } from "../admin-edit-trips-retail/admin-edit-trips-retail.component";
import { AdminGenerateInvoiceComponent } from '../admin-generate-invoice/admin-generate-invoice.component';
import { AdminElrViewComponent } from '../admin-elr-view/admin-elr-view.component';
import { Subscription } from "rxjs";

@Component({
  selector: "app-admin-trips",
  templateUrl: "./admin-trips.component.html",
  styleUrls: ["./admin-trips.component.css"],
})
export class AdminTripsComponent implements OnInit {
  tripType: any = "-1";
  allTrips: boolean = true;
  liveTrips: boolean = false;
  tripsArray: any;
  token: any;
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  received: boolean = true;
  completed: boolean = false;
  searchButton: boolean = true;
  search_Btn: boolean = false;
  toggleSearch: boolean = false;
  searchtripID: any = -1;
  matdialogref!: MatDialogRef<AdminTripsViewComponent>;
  matDialogref!: MatDialogRef<AdminCancelTripComponent>;
  MatDialogref!: MatDialogRef<AdminAddNotesComponent>;
  editsdialogref: MatDialogRef<AdminEditTripsComponent>;
  editsdialogrefs: MatDialogRef<AdminEditTripsRetailComponent>;
  retailDialogref: MatDialogRef<AdminRetailEditTripsComponent>;
  MatDialogrefe!: MatDialogRef<AdminTruckownerPaymentComponent>;
  matDialogue!: MatDialogRef<AdminRetailNotifyDriverComponent>;
  matDia: MatDialogRef<AdminTripsCancelComponent>;
  searchtrip_id: any = -1;
  loading: boolean = false;
  perPage: any = 10;
  searchQuery: any = -1;
  paginationTrips: boolean = true;
  Balance_amount: any;
  cancelButton: boolean = false;
  showPaymentIcon: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;

  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;
  private socketSubscription: Subscription;

  constructor(
    private matDialog: MatDialog,
    private services: AdminService,
    private commonService: CommonServices,
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    // this.pagination(1);
    // Retrieve last saved page from localStorage, default to 1 if not found
    const savedPage = sessionStorage.getItem("lastFetchPage");
    this.fetch_page = savedPage ? parseInt(savedPage) : 1;

    this.startPage = this.fetch_page;
    this.currentPage = this.fetch_page;

    const savedTripType = sessionStorage.getItem("lastAdminTripType");
    if (savedTripType) {
      this.tripType = savedTripType;
    }

    this.trips(this.searchtripID);
    this.checkTransactionAmount();

    this.commonService.getPublishedEvent("tripAssigned").subscribe({
      next: (data: any) => {
        if (data) {
          this.trips(this.searchtripID);
        }
      },
      error: (error) => {
        this.loading = false;
      },
      complete: () => console.log("✅ Subscription completed."),
    });
    let triptype = "trips";
    localStorage.setItem("tripType", triptype);
    this.commonService.getPublishedEvent("driverRoutes").subscribe({
      next: (data: any) => {
        if (data) {
          this.trips(this.searchtripID);
        }
      },
      error: (error) => {
        this.loading = false;
      },
      complete: () => console.log("✅ Subscription completed."),
    });
    this.commonService.getPublishedEvent("tripsList").subscribe({
      next: (data: any) => {
        if (data) {
          this.trips(this.searchtripID);
        }
      },
      error: (error) => {
        this.loading = false;
      },
      complete: () => console.log("✅ Subscription completed."),
    });
  }

  commonServi() { }

  checkTransactionAmount(): void {
    this.showPaymentIcon = this.tripsArray?.truckownerPaymentInfo[0].some(
      (payment: any) =>
        payment.transaction_amount ===
        this.tripsArray.paymentInfo[0]?.price_details.actual_price
    );
  }
  getTripsList(selectedTripType: any) {
    this.loading = true;
    this.tripType = selectedTripType;

    // Save tripType to sessionStorage and localStorage
    sessionStorage.setItem("lastAdminTripType", this.tripType);
    localStorage.setItem("lastTripType", this.tripType);

    if (this.tripType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    } else if (this.tripType == "upComing") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    } else if (this.tripType == "liveTrips") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    } else if (this.tripType == "completed") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    } else if (this.tripType == "cancelled") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    } else if (this.tripType == "quotes") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    } else if (this.tripType == "quoteBooked") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    } else if (this.tripType == "quoteCancel") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.trips(this.searchtripID);
      this.document_array = [];
    }
    this.loading = false;
  }
  GoToAllTrips() {
    this.allTrips = true;
    this.liveTrips = false;
  }
  GoToLiveTrips() {
    if (
      this.tripsArray?.paymentInfo?.payment_status === "partial-paid" ||
      this.tripsArray?.paymentInfo?.payment_status === "fully-paid"
    ) {
      this.liveTrips = true;
      this.allTrips = false;
    }
  }

  trips(type: any) {
    this.searchtripID = type;
    this.loading = true;
    this.services
      .GetAdminTrips(
        this.token,
        this.startPage,
        this.perPage,
        this.searchQuery,
        this.searchtripID,
        this.tripType
      )
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.tripsArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;

          // Save last page fetched to localStorage
          sessionStorage.setItem("lastFetchPage", this.fetch_page.toString());
        },

        (error) => {
          this.tripsArray = [];
          this.loading = false;
          if (error.status == 404) {
            this.paginationTrips = false;
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            this.matdialogref.close();
            this.matDialogref.close();
            this.MatDialogref.close();
            this.MatDialogrefe.close();
            this.matDialogue.close();
            window.sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            this.matdialogref.close();
            this.matDialogref.close();
            this.MatDialogref.close();
            this.MatDialogrefe.close();
            this.matDialogue.close();
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            this.matdialogref.close();
            this.matDialogref.close();
            this.MatDialogref.close();
            this.MatDialogrefe.close();
            this.matDialogue.close();
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  handleTripUpdate(data: any) {
    const existingTripIndex = this.tripsArray.findIndex(
      (trip: any) => trip.id === data.id
    );
    if (existingTripIndex !== -1) {
      this.tripsArray[existingTripIndex] = data;
    } else {
      this.tripsArray.push(data);
    }
  }
  viewTrips(item: any) {
    this.matdialogref = this.matDialog.open(AdminTripsViewComponent, {
      width: "80vw",
      data: item,
      autoFocus: false,
    });
    this.matdialogref.afterClosed().subscribe((x) => {
      this.trips(this.searchtripID);
    });
  }
  tripCancel() {
    this.matDialogref = this.matDialog.open(AdminCancelTripComponent, {
      width: "40vw",
      autoFocus: false,
    });
  }
  addNotes(tripId: any) {
    this.MatDialogref = this.matDialog.open(AdminAddNotesComponent, {
      width: "40vw",
      data: {
        _id: tripId,
        module_type: "trip",
      },
      autoFocus: false,
    });
    this.MatDialogref.afterClosed().subscribe((x) => {
      this.trips(this.searchtripID);
    });
  }

  cancelTrip(id: any) {
    this.matDia = this.matDialog.open(AdminTripsCancelComponent, {
      data: id,
      autoFocus: false,
    });
    this.matDia.afterClosed().subscribe((res) => {
      if (res) {
        this.trips(this.searchtripID);
      }
    });
  }

  retailNotifyDriver(item: any) {
    this.matDialogue = this.matDialog.open(AdminRetailNotifyDriverComponent, {
      height: "90vh",
      width: "80vw",
      data: item,
      autoFocus: false,
    });
    this.matDialogue.afterClosed().subscribe((x) => {
      this.trips(this.searchtripID);
    });
  }

  openELR(item: any) {
    const dialogRef = this.matDialog.open(AdminElrViewComponent, {
      height: "90vh",
      width: '80vw',
      autoFocus: false,
      data: item,
      // data: {
      //   url: item.lr_info.pdf_url
      // }
    });
  }

  openInvoiceDialog(item: any) {
    const dialogRef = this.matDialog.open(AdminGenerateInvoiceComponent, {
      height: "90vh",
      width: '80vw',
      data: item,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Invoice generated:', result);
        // Call API to save or generate invoice here
      }
    });
  }
  editTrips(item: any) {
    this.editsdialogref = this.matDialog.open(AdminEditTripsComponent, {
      width: "80vw",
      data: item,
      autoFocus: false,
    });
    this.editsdialogref.afterClosed().subscribe((x) => {
      this.trips(this.searchtripID);
    });
  }
  editTripsRetail(item: any) {
    this.editsdialogrefs = this.matDialog.open(AdminEditTripsRetailComponent, {
      width: "80vw",
      data: item,
      autoFocus: false,
    });
    this.editsdialogrefs.afterClosed().subscribe((x) => {
      this.trips(this.searchtripID);
    });
  }
  retailEditTrips(item: any) {
    this.retailDialogref = this.matDialog.open(AdminRetailEditTripsComponent, {
      width: "80vw",
      data: item,
      autoFocus: false,
    });
    this.retailDialogref.afterClosed().subscribe((x) => {
      this.trips(this.searchtripID);
    });
  }
  tripPayment(item: any) {
    this.MatDialogrefe = this.matDialog.open(AdminTruckownerPaymentComponent, {
      width: "40vw",
      panelClass: "truckowner-payment-dialog",
      height: "70vh",
      data: item,
      autoFocus: false,
    });

    this.MatDialogrefe.afterClosed().subscribe((x) => {
      this.trips(this.searchtripID);
    });
  }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1); // Prevent negative pages
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1; // Set the first page correctly
    } else if (page_status == "last") {
      newPage = this.last_page || 1; // Ensure last page is fetched correctly
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    // Save current page to localStorage
    sessionStorage.setItem("lastFetchPage", newPage.toString());

    this.trips(this.searchtripID);
  }

  consignment(item: any) {
    window.open(item.consignment_details.consignment_url);
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.previousValue = input.value;
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (this.cancelButton) {
      this.search_Btn = true;
      this.cancelButton = false;
    }

    this.isInputValid = value.trim().length >= 3;

    if (value.length === 0) {
      if (this.searchtripID !== -1) {
        this.callApi();
      }
    }
  }

  private callApi() {
    this.searchtripID = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.trips(this.searchtripID);
  }

  cancel() {
    this.toggleSearch = false;
    this.cancelButton = false;
    this.searchButton = true;
    this.search_Btn = true;
    this.isInputValid = false;
    this.previousValue = "";
    this.searchtripID = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.trips(this.searchtripID);
  }

  openSearch() {
    this.searchButton = false;
    this.cancelButton = false;
    this.toggleSearch = true;
    this.search_Btn = true;
    this.isInputValid = false;
    this.previousValue = "";
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }

  search(value: any) {
    if (!value) {
      this.searchtripID = -1;
      this.trips(this.searchtripID);
      this.fetch_page = 1;
      this.currentPage = 1;
      this.startPage = 1;
      this.searchButton = true;
      this.toggleSearch = false;
      this.cancelButton = false;
    } else {
      this.cancelButton = true;
      this.search_Btn = false;
      this.searchButton = false;
      this.startPage = 1;
      this.trips(value);
    }
  }
  convertCamelToNormalCase(camelCaseString: string): string {
    if (typeof camelCaseString !== "string" || camelCaseString.length === 0) {
      return camelCaseString;
    }

    return camelCaseString
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  }
}
